module.exports = __webpack_public_path__ + "static/media/287.a9de4c00.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/287.jpg
// module id = 973
// module chunks = 0